import React from 'react'
import CustomerForm from './CustomerForm'
import { CustomFormProps } from 'types/common'
import { yupResolver } from '@hookform/resolvers/yup'
import { supplierITAVS, supplierVS } from 'services/validations/crm/supplier'
import { supplierCategoryChoices } from 'services/cfg/form'
import { countrySwitch } from 'services/geo-management'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'

const supplierValidation = countrySwitch(supplierVS, {
  IT: supplierITAVS,
})

const SupplierForm: React.FC<CustomFormProps> = ({ children, ...rest }) => (
  <CustomerForm resolver={yupResolver(supplierValidation)} {...rest}>
    <KSelectInput
      source="category"
      label="form.fields.category"
      choices={supplierCategoryChoices}
    />
    {children}
  </CustomerForm>
)

export default SupplierForm
